import { actionsFactory } from '@ngneat/effects';

const switchAccountsActions = actionsFactory('switch-accounts');

export const loadPartnerLevelAccounts = switchAccountsActions.create(
  'Load Partner Level Accounts'
);
